import { Link } from "react-router";
import { AlertCircle, ArrowRight } from "lucide-react";
import type { AdminUnboardedPartner } from "./use-admin-deal";

// SPA port of NoPortalYetPanel. Surfaces partners that have a HubSpot
// record but no `partner_users` row — they can't see this deal on their
// portal side. Pass 2 §9.4 P1 flagged this as a frequent omission
// Bookboost staff don't notice until a partner asks why the deal is
// hidden.

export function NoPortalYetPanel({
  unboardedPartners,
}: {
  unboardedPartners: AdminUnboardedPartner[];
}) {
  if (unboardedPartners.length === 0) return null;

  return (
    <section
      aria-label="Portal access status"
      className="rounded-lg border border-amber-500/30 bg-amber-500/5 px-4 py-3"
    >
      <div className="flex items-start gap-2">
        <AlertCircle className="mt-0.5 h-4 w-4 shrink-0 text-amber-600 dark:text-amber-500" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium text-foreground">
            {unboardedPartners.length === 1
              ? "This partner doesn't have portal access yet"
              : `${unboardedPartners.length} partners don't have portal access yet`}
          </p>
          <p className="mt-0.5 text-xs text-muted-foreground">
            They can&apos;t see this deal on their side until you assign an
            experience.
          </p>
          <ul className="mt-2 space-y-1">
            {unboardedPartners.map((p) => (
              <li key={p.partner_id}>
                <Link
                  to={`/admin/partners/${p.partner_id}`}
                  className="inline-flex items-center gap-1 text-xs font-medium text-amber-700 hover:underline dark:text-amber-400"
                >
                  Assign experience to {p.partner_name}
                  <ArrowRight className="h-3 w-3" />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
